// Project Base-url
export const baseURL = 'https://private.blacktel.io'
// URL for Sign-in & SignUp
export const userRegister = baseURL + '/register'
export const userLogin = baseURL + '/login'
export const userRecover = baseURL + '/user-recover'

// URL for the recent activity
export const recentActivity = baseURL + '/user-activity'
export const userActivityDelete = baseURL + '/user-activity-delete'

// URL for user detail
export const userDetail = baseURL + '/user-detail'

// URL for the calls
export const userCallsGrouped = baseURL + '/user-calls-grouped'
export const userCallsGroupedDeleteAll = baseURL + '/user-calls-grouped-delete-all'
export const userCallsGroupedDelete = baseURL + '/user-calls-grouped-delete'

// URL for the messages
export const groupedMessageList = baseURL + '/user-messages-grouped'
export const userMsgList = baseURL + '/user-messages'
export const userContactList = baseURL + '/user-contact'
export const getVirtualNumber = baseURL + '/user-numbers'
export const userMessagesDeleteAll = baseURL + '/user-messages-grouped-delete-all'

export const sendSms = baseURL + '/virtualphone-sms'
export const userChatDelete = baseURL + '/user-messages-grouped-delete'
export const userChatMessageDelete = baseURL + '/user-messages-delete'
export const getNumberDetail = baseURL + '/tool-parsenumber'
export const messagesUnreadCount = baseURL + '/user-messages-count-unread'
export const callUnreadCount = baseURL + '/user-calls-count-unread'

// URLs for the faxes
export const groupedFaxesList = baseURL + '/user-fax-grouped'
export const userFaxUrl = baseURL + '/user-fax'
export const sendFaxUrl = baseURL + '/virtualphone-fax'
export const userFaxesGroupDelete = baseURL + '/user-fax-grouped-delete'
export const userFaxDeleteUrl = baseURL + '/user-fax-delete'
export const userFaxListenUrl = baseURL + '/user-fax-listen'
export const userFaxesDeleteAll = baseURL + '/user-fax-grouped-delete-all'

// URL for Activity
export const deleteAllActivity = baseURL + '/user-activity-delete-all'

// URL for calling
export const outBoundcall = baseURL + '/virtualphone-call'
export const userRecordsListUrl = baseURL + '/user-records'
export const deleteRecordUrl = baseURL + '/user-record-delete'
export const deleteAllRecordsUrl = baseURL + '/user-record-delete-all'

// URL for virtualNumber Services
export const virtualSearch = baseURL + '/virtualnumber-search'
export const userNumberDelete = baseURL + '/user-number-delete'
export const addVirtualNumberRent = baseURL + '/virtualnumber-rent'
export const userMessageListen = baseURL + '/user-messages-listen'
export const newDeviceNumber = baseURL + '/user-device-add'

// user level 1 and 2 verification
export const userLevelVerification = baseURL + '/user-verify'

export const deviceVerify = baseURL + '/user-device-verify'
export const userVerifySMSCode = baseURL + '/user-verify-smscode'
export const codeResend = baseURL + '/user-device-sendcode'
export const userDeviceEdit = baseURL + '/user-device-edit'
export const userNumberServiceDetail = baseURL + '/user-number-detail'
export const userNumberSetting = baseURL + '/user-number-setting'
export const userNumberPlanChange = baseURL + '/user-number-plan'
export const userNumberRenew = baseURL + '/user-number-renew'
export const virtualNumberCountry = baseURL + '/virtualnumber-countries'
export const userRegulatoryBundles = baseURL + '/user-regulatory-bundles'

// URL for addressBook contact
export const userAddressbook = baseURL + '/user-addressbook'
export const addressBookAdd = baseURL + '/user-addressbook-add'
export const addressBookDelete = baseURL + '/user-addressbook-delete'
export const addressBookEdit = baseURL + '/user-addressbook-edit'

// URL for Twilio services
export const capabilityToken = baseURL + '/twilio-capabilitytoken'

// URL for Tips
export const getAllTips = baseURL + '/tips'


// URL for Settings
export const generalSettingSave = baseURL + '/user-settings'
export const changePasswordSave = baseURL + '/user-password'

// URL for Language list
export const languageList = baseURL + '/sites'

// URL for timezone list
export const timezoneList = baseURL + '/tool-timezones'

// URL for user are eligible for free virtual number
export const billingCanHaveFreeNumber = baseURL + '/billing-can-have-free-number'

// URL for buy billing credits in account 
export const billingBuyCredits = baseURL + '/billing-buycredits'

// URL for credit card (stripe)
export const billingStripeCards = baseURL + '/billing-stripe-cards'

export const billingStripeCardAdd = baseURL + '/billing-stripe-card-add'

export const billingStripeCardDelete = baseURL + '/billing-stripe-card-delete'

// URL Revive Number
export const virtualNumberRevive = baseURL +  '/virtualnumber-revive'

export const contactSupportRevive = baseURL + '/contact-revive'

//URL Search Everywhere
export const searchEverywhere = baseURL + '/search-everywhere'
